import React, { useState } from "react";
import axios from "axios";

const InputsOne = ({ handleChange, formData, handleSubmit }) => {
  return (
    <>
      <div className="input-field-wrapper-edit-profile">
        <div className="input-wrapper-edit-profile">
          <input
            className="form-field-edit-profile w-input"
            maxLength={256}
            name="first_name"
            placeholder="Name"
            type="text"
            id="Name-3"
            value={formData?.first_name}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="input-field-wrapper-edit-profile">
        <div className="input-wrapper-edit-profile">
          <input
            className="form-field-edit-profile w-input"
            maxLength={256}
            name="email"
            placeholder="Email"
            type="email"
            id="email"
            value={formData?.email}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="edit-profile-input-flex">
        <div className="input-field-wrapper-edit-profile">
          <div className="input-wrapper-edit-profile">
            <input
              className="form-field-edit-profile w-input"
              maxLength={256}
              name="Gender"
              placeholder="Gender"
              type="text"
              id="Gender"
              value={formData?.gender}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="input-field-wrapper-edit-profile">
          <div className="input-wrapper-edit-profile">
            <input
              className="form-field-edit-profile w-input"
              maxLength={256}
              name="Age"
              placeholder="Age"
              type="number"
              id="Age"
              value={formData?.age}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      </div>
      <div className="input-wrapper-edit-profile">
        <input
          className="form-field-edit-profile w-input"
          maxLength={256}
          name="about_me"
          placeholder="something about you"
          type="text"
          id="Name-3"
          value={formData?.about_me}
          onChange={handleChange}
          required
        />
      </div>
      {/* <div onClick={handleSubmit} type="submit">
        Update Profile
      </div> */}
    </>
  );
};

export default InputsOne;
